import { useRouter } from "@tanstack/react-router"
import { CardDescription, CardTitle } from "design-system/molecules/Card"
import { useResetPasswordMutation } from "modules/auth/hooks/useResetPasswordMutation"
import { useAuth } from "modules/shared/hooks/useAuth"
import { useTranslation } from "react-i18next"
import { Route as ResetPasswordRoute } from "routes/_base/_public/reset-password"
import { ResetPasswordSchema } from "schema"
import { z } from "zod"
import { AuthWrapper } from "../AuthWrapper"
import { ResetPasswordForm } from "./ResetPasswordForm"

export const RestorePassword = () => {
  const { onLogin } = useAuth()
  const { mutateAsync, isPending } = useResetPasswordMutation()
  const router = useRouter()
  const { t } = useTranslation()
  const { token, activate } = ResetPasswordRoute.useSearch()
  const mode = activate ? "activateAccount" : "default"

  const onSubmitSignup = async (data: z.infer<typeof ResetPasswordSchema>) => {
    const response = await mutateAsync(data)
    onLogin(response, router)
  }

  return (
    <AuthWrapper>
      <div className="flex flex-col gap-8 w-full justify-center items-center">
        <div className="flex flex-col gap-2 items-center text-center">
          <CardTitle>{t(`auth.resetPassword.title.${mode}`)}</CardTitle>
          <CardDescription>{t(`auth.resetPassword.description.${mode}`)}</CardDescription>
        </div>
        <ResetPasswordForm
          onSubmit={onSubmitSignup}
          isPending={isPending}
          mode={mode}
          token={token}
        />
      </div>
    </AuthWrapper>
  )
}
